import { css } from "@emotion/react";
import { designTokens } from "@/theme";

// Design system fonts — serif for display, Inter for UI, JetBrains Mono
// for numerals. Source Serif 4 is the open-source fallback for the
// commercial GT Sectra / Tiempos Headline specified in DESIGN.md.
const FONTS_IMPORT = `@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=JetBrains+Mono:wght@400;500&family=Source+Serif+4:ital,opsz,wght@0,8..60,400;0,8..60,500;1,8..60,400&display=swap");`;

const t = designTokens.light;

export default css`
  ${FONTS_IMPORT}

  * {
    box-sizing: border-box;
  }

  :root {
    --paper: ${t.paper};
    --paper-raised: ${t.paperRaised};
    --ink: ${t.ink};
    --ink-muted: ${t.inkMuted};
    --rule: ${t.rule};
    --rule-strong: ${t.ruleStrong};
    --accent: ${t.accent};
    --accent-deep: ${t.accentDeep};
    --kelp: ${t.kelp};
    --buoy: ${t.buoy};
    --chart-swell: ${t.chartSwell};
    --chart-wind: ${t.chartWind};
  }

  body {
    margin: 0;
    background-color: ${t.paper};
    color: ${t.ink};
    font-variant-numeric: tabular-nums;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  li {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  /* Thin paper-toned scrollbars — visible but not dashboard-chrome loud. */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background: ${t.rule};
    border-radius: 3px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${t.ruleStrong};
  }
`;
